import {
    Outlet,
    useNavigate
} from 'react-router-dom';


import {
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformHeaderToolbar,
    PlatformLoader,
    PlatformNavbarMenuItem,
    PlatformNavbarMode,
} from '@flexinet/ui-components';
import {
    Suspense,
    useState
} from "react";
import {PortalNavbar} from "./menu-items/pages/PortalNavbar.tsx";
import {
    AiOutlineLayout,
    AiOutlineLogout,
    AiOutlineQuestionCircle
} from "react-icons/ai";
import config from "../config";
import {getMenuItems} from "./menu-items/data/menus.tsx";
import {ActionIcon} from '@mantine/core';
import {PlatformHeaderNavigationMenuItem} from "@flexinet/ui-components/dist/page-elements/PlatformHeaderNavigationMenu/types";
import {useUserAttributes} from "../hooks/useUserAttributes.ts";
import {useDisclosure} from "@mantine/hooks";

export const UserLayout = () => {

    const navigate = useNavigate()
    const [mode, setMode] = useState(PlatformNavbarMode.MEDIUM)
    const [navbarWidth, setNavbarWidth] = useState(310)
    const [opened, {toggle}] = useDisclosure();

    let header = <PlatformHeader/>


    let userInfo = {} as { name: string, email: string }

    const {
        givenName,
        familyName,
        email,
    } = useUserAttributes()

    console.debug('UserLayout user attributes: ', givenName, familyName, email)

    if (givenName && familyName && email) {
        userInfo = {
            name: [givenName, familyName].join(' '),
            email: email
        }
    }


    const additionalMenuItems = [{
        title: 'Sign Out',
        link: '/sign-out',
        onClick: () => navigate('/sign-out'),
        icon: <AiOutlineLogout/>
    }]


    let topLevelMenuItems = [] as PlatformNavbarMenuItem[]
    // let navigationMenuItems = [] as { title: string, onClick: () => void }[]
    let navigationMenuItems = [] as PlatformHeaderNavigationMenuItem[]

    const showTopLevelMenu = false
    if (email && showTopLevelMenu) {
        topLevelMenuItems = getMenuItems()
        navigationMenuItems = topLevelMenuItems.map(item => ({
            title: item.label,
            onClick: () => {
                navigate(item.link as string)
            }
        })) as PlatformHeaderNavigationMenuItem[]
    }

    const toolbar = <PlatformHeaderToolbar
        user={userInfo}
        portalUrl={config.platform.portal}
        additionalMenuItems={additionalMenuItems}
        additionalToolbarItems={[
            <ActionIcon
                size={'lg'}
                variant={'subtle'}
                title={'Toggle Navbar Layout'}
                onClick={toggle}
            >
                <AiOutlineLayout size={'1.8em'}/>
            </ActionIcon>,
            <ActionIcon
                size={'lg'}
                variant={'subtle'}
                title={'Docs'}
                onClick={() => window.open('https://docs.flexi.network')}>
                <AiOutlineQuestionCircle size={'1.8em'}/>
            </ActionIcon>
        ]}
    />

    header = <PlatformHeader
        navigationMenu={<PlatformHeaderNavigationMenu menuItems={navigationMenuItems}/>}
        toolbar={toolbar}/>

    const changeMode = (mode: PlatformNavbarMode) => {
        setMode(mode)
        if (mode === 'medium') {
            setNavbarWidth(310)
        } else {
            setNavbarWidth(70)
        }
    }

    return (
        <PlatformAppShell
            platformNavbar={<PortalNavbar mode={mode} changeMode={changeMode}/>}
            platformHeader={header}
            platformFooter={<PlatformFooter/>}
            header={{height: 80}}
            footer={{height: 100}}
            navbar={{
                width: navbarWidth,
                breakpoint: 'sm',
                collapsed: {
                    desktop: opened,
                    mobile: !opened
                }
            }}
        >


            <Suspense fallback={<PlatformLoader/>}>
                <Outlet/>
            </Suspense>


        </PlatformAppShell>
    );


};
